import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { history } from '../../../../history';
import { formatKm, styleMerge } from '../../../../utils/utils';
import VehicleDetailsLabelAndValue from '../VehicleDetailsLabelAndValue';
import i18n from '../../../../i18n';

class MaintenanceListItem extends React.Component {
  state = {
    isHovering: false,
  };

  getContainerStyle = () => {
    const { isSelected } = this.props;

    let style = styles.listItemContainer;

    if (isSelected) {
      style = styleMerge(style, styles.selected);
    }

    return style;
  };

  getWorkshopName = () => {
    const { maintenance } = this.props;
    if (maintenance.workshop && maintenance.workshop.name) {
      return maintenance.workshop.name;
    }
    if (maintenance.organization_name) {
      return maintenance.organization_name;
    }
    return '-';
  };

  isManualEntry = () => {
    const { maintenance } = this.props;
    return maintenance.source === 'organization' || maintenance.source === 'carbook';
  };

  render() {
    const { maintenance, vehicle } = this.props;
    const { isHovering } = this.state;
    const isManual = this.isManualEntry();

    return (
      <Link
        to={
          history.location.pathname.includes('workshop-vehicle')
            ? `/workshop-vehicle/${vehicle.id}/maintenances/${maintenance.id}`
            : `/vehicle/${vehicle.id}/maintenances/${maintenance.id}`
        }
      >
        <div style={this.getContainerStyle()}>
          <div style={styles.contentWrapper}>
            <div style={{ flex: 1 }}>
              <VehicleDetailsLabelAndValue
                label={`${moment(maintenance.pickup_date).format(
                  'D.M.Y',
                )} | ${formatKm(maintenance.km)}`}
                value={this.getWorkshopName()}
              />
            </div>
            <div style={styles.badgeContainer}>
              {isManual && (
                <div
                  style={styles.manualBadge}
                  title={i18n.t('manualMaintenanceEntry', { ns: 'VehicleDetailsView' })}
                >
                  <img
                    src='/img/edit.svg'
                    alt={i18n.t('enteredInOvio', { ns: 'VehicleDetailsView' })}
                    title={i18n.t('enteredInOvio', { ns: 'VehicleDetailsView' })}
                    style={styles.manualBadgeIcon}
                  />
                </div>
              )}
              {maintenance.is_last_periodic_maintenance && (
                <div
                  style={{
                    ...styles.badge,
                    opacity: isHovering ? 1 : 0.8,
                  }}
                  title={i18n.t('previousPeriodicMaintenance', { ns: 'VehicleDetailsView' })}
                  onMouseEnter={() => this.setState({ isHovering: true })}
                  onMouseLeave={() => this.setState({ isHovering: false })}
                >
                  <img
                    src="/img/icon_periodic_maintenance.png"
                    alt={i18n.t('previousPeriodicMaintenance', { ns: 'VehicleDetailsView' })}
                    style={styles.badgeIcon}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

const styles = {
  listItemContainer: {
    padding: 10,
    borderBottom: '1px solid rgba(255,255,255,.3)',
  },
  selected: {
    borderLeft: '4px solid #27bbff',
  },
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  badgeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginLeft: 4,
    flexShrink: 0,
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
  },
  badgeIcon: {
    width: 48,
    height: 48,
  },
  manualBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.6,
  },
  manualBadgeIcon: {
    width: 18,
    height: 18,
    filter: 'brightness(0) invert(1)',
  },
};

export default MaintenanceListItem;
